import { useQuery as useQueryOriginal } from 'react-query';
import qs from 'qs';
import useApi from 'hook/useApi';
import { AxiosResponse } from 'axios';
import useApiPath from 'hook/useApiPath';

interface QueryParam {
  [key: string]: string | number | null | undefined;
}

export default function useLazyQuery<ApiResponse>(
  path: string,
  options?: {
    param?: QueryParam;
    onSuccess?: (data: AxiosResponse<ApiResponse, any>) => void;
    onError?: (data: any) => void;
  },
) {
  const apiPath = useApiPath();
  const pathURL = `${apiPath
    }${path}${qs.stringify(options?.param, { addQueryPrefix: true })}`;
  const api = useApi();

  const getQuery = useQueryOriginal(
    [pathURL],
    async () => api.get<ApiResponse>(pathURL),
    {
      onSuccess: (data) => {
        if (options && typeof options?.onSuccess === 'function') {
          options.onSuccess(data);
        }
      },
      onError: (data) => {
        if (options && typeof options?.onError === 'function') {
          options.onError(data);
        }
      },
      enabled: false,
    },
  );

  return { ...getQuery, refetch: () => getQuery.refetch() };
}
